import { render } from "./AmandemenImkpModal.vue?vue&type=template&id=4942cefc&scoped=true"
import script from "./AmandemenImkpModal.vue?vue&type=script&lang=js"
export * from "./AmandemenImkpModal.vue?vue&type=script&lang=js"

import "./AmandemenImkpModal.vue?vue&type=style&index=0&id=4942cefc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4942cefc"]])

export default __exports__